import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenCsInquiryQuestion from '../../../../views/cs/inquiry/common/OpenCsInquiryQuestion';
import { csInquiryActions } from '../../../../store/modules/cs/inquiry';

class OpenCsInquiryQuestionContainer extends Component {
  render() {
    return <OpenCsInquiryQuestion {...this.props} />;
  }
}

const mapDispatchToProps = {
  toggleModal: csInquiryActions.toggleModal,
};

export default connect(null, mapDispatchToProps)(OpenCsInquiryQuestionContainer);
